import React from "react";
import { makeStyles, Button, Box, Typography } from "@material-ui/core";
import { Facebook, Visibility } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import Appbar from "../../components/Appbar";
import Footer from "../../components/Footer";
import EditPlano from "../../components/EditPlano";
import EditParceiro from "../../components/EditParceiro";
import Logout from "../../components/Logout";

export default function Configuracoes(){
  const classes = useStyles();
  const history = useHistory();

  const handleFacebookIntegration = () => {
    history.push('/integracao-facebook');
  };

  const handlePublications = () => {
    history.push('/configuracoes/publicacoes');
  };

  return(
    <div className={classes.root}>
      <Appbar/>
      <div className={classes.content}>
        <div className={classes.limit}>
          <Logout/>
          
          <Box className={classes.facebookSection}>
            <Typography variant="h6" gutterBottom>
              Integração com Facebook
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Gerencie tokens, configurações e sincronização com o Facebook
            </Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Facebook />}
              onClick={handleFacebookIntegration}
              className={classes.facebookButton}
            >
              Abrir Integração Facebook
            </Button>
          </Box>

          <Box className={classes.facebookSection}>
            <Typography variant="h6" gutterBottom>
              Publicações das redes sociais
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Oculte ou exiba conteúdos do Facebook e Instagram no site, sem removê-los da sincronização.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Visibility />}
              onClick={handlePublications}
              className={classes.facebookButton}
            >
              Gerenciar publicações
            </Button>
          </Box>
          
          <EditPlano/>
          <EditParceiro/>
        </div>
      </div>
      <Footer/>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    width: "100vw",
    flexDirection: "column",
    display: "flex",
  },
  content: {
    flex: 1,
    justifyContent: "center",
    display: "flex",
    paddingBottom: "50px",
  },
  limit: {
    width: "100%",
    maxWidth: "1376px",
    flexDirection: "column",
    paddingLeft: "15px",
    paddingRight: "15px",
    alignItems: "center",
    display: "flex",
  },
  facebookSection: {
    width: "100%",
    maxWidth: "600px",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    backgroundColor: "#f5f5f5",
    borderRadius: theme.spacing(1),
    textAlign: "center",
    border: "1px solid #e0e0e0",
  },
  facebookButton: {
    marginTop: theme.spacing(2),
    background: "linear-gradient(45deg, #1877F2 30%, #42A5F5 90%)",
    color: "white",
    '&:hover': {
      background: "linear-gradient(45deg, #166FE5 30%, #1976D2 90%)",
    },
  },
}));
